import React from "react";
import styled from "styled-components";


const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${({ align }) => align};
    justify-content: ${({ justify }) => justify};
    padding: ${({ padding }) => padding};
    margin: ${({ margin }) => margin};
    position: ${({ position }) => position};
	${({ debug }) => debug ? 'border: 1px dashed black;' : ''}

  @media (max-width: 768px) {
    position: unset;
  }
`;

export default ({
  children, debug = false, align = 'center', justify = 'center', padding = '0', margin = '0', style, position, ...props
}) => (
  <Row debug={debug} align={align} justify={justify} padding={padding} margin={margin} style={style} position={position} {...props}>
    {children}
  </Row>
)
